import { getCurrentInstance } from 'vue'
import mitt from 'mitt'

export default () => {
  const install = () => {
    const emitter = mitt();
    getCurrentInstance().appContext.config.globalProperties.emitter = emitter
  }

  const emitter = () => {
    if (typeof getCurrentInstance().appContext.config.globalProperties.emitter == 'undefined') {
      install()
    }

    return getCurrentInstance().appContext.config.globalProperties.emitter
  }

  return {
    install,
    emitter,
  }
}
